export default "__VITE_ASSET__D1IN6Muu__"